(() => {
  if (window.__rareblaqUI) return;
  window.__rareblaqUI = true;
  let opener = null;
  const unlock = () => {
    if (!document.querySelector('.rbq-dialog[open]')) document.documentElement.classList.remove('rbq-modal-open');
    if (opener?.isConnected) opener.focus();
  };
  const openDialog = (dialog, trigger) => {
    if (!dialog || dialog.open) return;
    opener = trigger;
    dialog.showModal();
    document.documentElement.classList.add('rbq-modal-open');
    dialog.addEventListener('close', unlock, { once: true });
  };
  document.addEventListener('click', (event) => {
    const preview = event.target.closest('[data-rbq-preview]');
    if (preview) {
      const dialog = document.getElementById('rbq-piece-dialog');
      if (!dialog) return;
      event.preventDefault();
      const data = preview.dataset;
      const image = dialog.querySelector('[data-rbq-dialog-image]');
      image.src = data.image;
      image.alt = data.alt || data.title;
      dialog.querySelector('[data-rbq-dialog-title]').textContent = data.title;
      dialog.querySelector('[data-rbq-dialog-collection]').textContent = data.collection || 'DROP _001';
      dialog.querySelector('[data-rbq-dialog-description]').textContent = data.description;
      dialog.querySelector('[data-rbq-dialog-enquire]').href = 'mailto:' + (dialog.dataset.email || 'sales@rareblaq.com') + '?subject=' + encodeURIComponent('Enquiry — ' + data.title + ' / ' + (data.collection || 'DROP _001'));
      openDialog(dialog, preview);
      return;
    }
    const search = event.target.closest('[data-rbq-search]');
    if (search) { openDialog(document.getElementById('rbq-search-dialog'), search); return; }
    const close = event.target.closest('[data-rbq-close]');
    if (close) { close.closest('dialog').close(); return; }
    if (event.target.matches('dialog.rbq-dialog')) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
    const menuLink = event.target.closest('.rbq-mobilelinks a');
    if (menuLink) menuLink.closest('details').open = false;
    const menu = document.querySelector('.rbq-menu[open]');
    if (menu && !menu.contains(event.target)) menu.open = false;
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('.rbq-menu[open]').forEach(menu => menu.open = false);
  });
  document.addEventListener('shopify:section:unload', () => {
    if (!document.querySelector('.rbq-dialog[open]')) document.documentElement.classList.remove('rbq-modal-open');
  });
})();

(() => {
  if (window.__rareblaqRooms) return;
  window.__rareblaqRooms = true;
  const activate = (rooms, id, focus = false) => {
    const tabs = [...rooms.querySelectorAll('[role="tab"]')];
    const selected = tabs.find(tab => tab.getAttribute('aria-controls') === id);
    if (!selected) return false;
    tabs.forEach(tab => {
      const active = tab === selected;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) panel.hidden = !active;
    });
    if (focus) selected.focus();
    return true;
  };
  const initialize = () => {
    const rooms = document.getElementById('rare-world');
    if (!rooms) return;
    const id = location.hash.slice(1);
    if (!activate(rooms, id)) activate(rooms, 'listening-room');
  };
  document.addEventListener('click', event => {
    const rooms = document.getElementById('rare-world');
    if (!rooms) return;
    const tab = event.target.closest('.rbq-room-tabs [role="tab"]');
    const link = event.target.closest('[data-rbq-room]');
    if (!tab && !link) return;
    if (link && (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0)) return;
    const id = tab ? tab.getAttribute('aria-controls') : link.dataset.rbqRoom;
    if (!activate(rooms, id)) return;
    event.preventDefault();
    history.replaceState(null, '', '#' + id);
    if (link) {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      rooms.scrollIntoView({ block: 'start', behavior: reduced ? 'auto' : 'smooth' });
      document.getElementById(id)?.focus({ preventScroll: true });
      document.querySelectorAll('.rbq-menu[open]').forEach(menu => menu.open = false);
    }
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('.rbq-room-tabs [role="tab"]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const rooms = tab.closest('.rbq-rooms');
    const tabs = [...rooms.querySelectorAll('[role="tab"]')];
    const current = tabs.indexOf(tab);
    let next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    event.preventDefault();
    activate(rooms, tabs[next].getAttribute('aria-controls'), true);
  });
  window.addEventListener('hashchange', initialize);
  document.addEventListener('shopify:section:load', initialize);
  initialize();
})();

(() => {
  if (window.__rareblaqCampaigns) return;
  window.__rareblaqCampaigns = true;
  const campaigns = new Map();
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-rbq-campaign]').forEach(root => {
      if (campaigns.has(root)) return;
      const films = [...root.querySelectorAll('[data-rbq-film-src]')];
      const player = root.querySelector('[data-rbq-campaign-player]');
      if (!films.length || !player) return;
      const toggle = root.querySelector('[data-rbq-film-toggle]');
      const previous = root.querySelector('[data-rbq-film-previous]');
      const next = root.querySelector('[data-rbq-film-next]');
      const count = root.querySelector('[data-rbq-film-count]');
      const message = root.querySelector('[data-rbq-film-message]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const controller = new AbortController();
      const listen = (target, type, callback) => target.addEventListener(type, callback, { signal: controller.signal });
      let index = 0;
      let loadedIndex = -1;
      let attempt = 0;
      let wanted = root.dataset.autoplay !== 'false' && !reducedMotion.matches;
      let inView = !('IntersectionObserver' in window);
      const updateControls = () => {
        const playing = !player.paused && !player.ended;
        toggle.textContent = playing ? 'PAUSE' : 'PLAY';
        toggle.setAttribute('aria-label', playing ? 'Pause campaign films' : 'Play campaign films');
        count.textContent = `${String(index + 1).padStart(2, '0')} / ${String(films.length).padStart(2, '0')}`;
        count.setAttribute('aria-label', `Film ${index + 1} of ${films.length}`);
      };
      const load = () => {
        if (loadedIndex === index) return;
        attempt++;
        root.dataset.filmReady = 'false';
        message.hidden = true;
        player.preload = 'auto';
        player.src = films[index].dataset.rbqFilmSrc;
        player.muted = true;
        player.load();
        loadedIndex = index;
      };
      const sync = () => {
        if (!wanted || !inView || document.hidden) {
          attempt++;
          player.pause();
          updateControls();
          return;
        }
        load();
        const currentAttempt = ++attempt;
        player.play().catch(error => {
          if (currentAttempt !== attempt || error.name === 'AbortError') return;
          wanted = false;
          updateControls();
        });
      };
      const select = value => {
        index = (value + films.length) % films.length;
        load();
        updateControls();
        sync();
      };
      listen(toggle, 'click', () => {
        wanted = player.paused;
        if (wanted) inView = true;
        sync();
      });
      listen(previous, 'click', () => select(index - 1));
      listen(next, 'click', () => select(index + 1));
      listen(player, 'ended', () => { if (wanted) select(index + 1); });
      listen(player, 'playing', () => { root.dataset.filmReady = 'true'; updateControls(); });
      listen(player, 'pause', updateControls);
      listen(player, 'loadeddata', () => {
        // A paused manual selection still shows the selected film's first frame.
        root.dataset.filmReady = 'true';
      });
      listen(player, 'error', () => {
        attempt++;
        wanted = false;
        loadedIndex = -1;
        root.dataset.filmReady = 'false';
        message.hidden = false;
        updateControls();
      });
      listen(document, 'visibilitychange', sync);
      listen(reducedMotion, 'change', () => {
        if (reducedMotion.matches) { wanted = false; sync(); }
      });
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting;
        sync();
      }, { threshold: 0.05 }) : null;
      root.querySelector('[data-rbq-film-controls]').hidden = false;
      previous.hidden = next.hidden = films.length < 2;
      updateControls();
      if (observer) observer.observe(root); else sync();
      campaigns.set(root, () => {
        attempt++;
        controller.abort();
        observer?.disconnect();
        player.pause();
        player.removeAttribute('src');
        player.load();
        campaigns.delete(root);
      });
    });
  };
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    campaigns.forEach((dispose, root) => { if (event.target.contains(root)) dispose(); });
  });
  initialize();
})();
